<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Please set LastEditors
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-05-05 11:31:53
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalType\editApprovalType.vue
 -->
<template>
  <ContentLayout
    :editBtn="!iSEdited && hasBtn('edit-admin-approval-type')"
    @edit="iSEdited = true"
    :delBtn="hasBtn('delete-admin-approval-type')"
    @delete="
      $confirmDo($t('label_essweb_approvalType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
    backgroundClass="white"
    :initData="approvalTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'flow_type_name',
      'color_code',
      'flow_type_description',
      'flow_icon',
      'remarks',
    ]"
    :title="
      iSEdited
        ? $t('label_essweb_approvalType_form_editTitle')
        : $t('label_essweb_approvalType_form_viewTitle')
    "
    widthClass="max-1000"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              maxlength="100"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="approvalTypeData.flow_type_name"
              @change="
                (valueArr) => {
                  approvalTypeData.flow_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_approvalType_form_approvalTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_approvalType_form_tagColorLabel")
            }}</v-sheet>
            <SelectColor
              :items="$Colors"
              v-model="approvalTypeData.color_code"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :appendIcon="iSEdited ? 'arrow_drop_down' : ''"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="500"
              :readonly="!iSEdited"
              :bindData="approvalTypeData.flow_type_description"
              @change="
                (valueArr) => {
                  approvalTypeData.flow_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_approvalType_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_approvalType_form_flowIconLabel")
            }}</v-sheet>
            <ImgDragUpdate
              @change="(img) => (approvalTypeData.attachments = img)"
              :defaultImageList="approvalTypeData.attachments"
              single
              :disabled="!iSEdited"
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_approvalType_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="approvalTypeData.remarks"
              dense
              counter="500"
              single-line
              :filled="iSEdited"
              :readonly="!iSEdited"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- tools -->
    <template v-slot:tools-main> </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editApprovalType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: true,
      isChanged: false,
      approvalTypeData: {
        flow_type_name: "",
        color_code: "",
        flow_type_description: "",
        attachment_uuid: null,
        remarks: "",
      },
    };
  },
  mounted() {
    // this.approvalTypeData.flow_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.approvalTypeData.flow_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getBtnPermissionList();
    this.getDetail();
  },
  methods: {
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/get-approval-type-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["flow_type_name_save"] = res.data.flow_type_name;
        res.data.flow_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.flow_type_name
        );
        res.data["flow_type_description_save"] = res.data.flow_type_description;
        res.data.flow_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.flow_type_description
        );
        if (res.data["attachments"] && res.data["attachments"].length) {
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        } else {
          that.approvalTypeData.attachments = [];
        }
        // res.data["attachment_uuid"] = res.data["attachments"].length
        //   ? res.data["attachments"][0]
        //   : null;
        that.approvalTypeData = res.data;
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/update-approval-type-table/",
        data: {
          uuid: this.$route.params.id,
          flow_type_name: this.$transCommonLangKey(
            this.approvalTypeData.flow_type_name,
            this.approvalTypeData.flow_type_name_save
          ),
          color_code: this.approvalTypeData.color_code,
          flow_type_description: this.$transCommonLangKey(
            this.approvalTypeData.flow_type_description,
            this.approvalTypeData.flow_type_description_save
          ),
          attachment_uuid: this.approvalTypeData["attachments"]["uuid"],
          remarks: this.approvalTypeData.remarks,
        },
      }).then((res) => {
        that.$toBack();
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalType_form_updateApprovalTypeSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_type",
        url: "/approval-type/delete-approval-type-table/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalType_list_deleteApprovalTypeSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
  },
};
</script>
